import { Type } from '@angular/core';
import { MenuHeaderPlainJaneComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-plain-jane/menu-header-plain-jane.component';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { PrintMenu } from '../print-menu';
import { PrintHeaderLayoutType } from '../../enum/shared/print-header-layout-type.enum';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnCannabinoidType } from '../../enum/shared/section-column-cannabinoid-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class PlainJaneMenu extends PrintMenu {
  getPageBottomMargin(): string {
    return '0.5in';
  }

  getPageTopMargin(): string {
    return '0.5in';
  }

  getPageLeftMargin(): string {
    return '0.5in';
  }

  getPageRightMargin(): string {
    return '0.5in';
  }

  getThemeClass(): string {
    return 'plain-jane-theme';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderPlainJaneComponent;
  }

  getPrintHeaderLayoutType(): PrintHeaderLayoutType {
    return this.menuOptions?.printHeaderLayout || PrintHeaderLayoutType.FirstPage;
  }

  getShowSectionHeaderColorAsIcon(): boolean {
    return true;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Poppins.SemiBold_600,
      FONT.Poppins.ExtraBold_800,
      FONT.RealistNarrow.Regular_400,
      FONT.RealistNarrow.Bold_700,
      FONT.RealistNarrow.ExtraBold_800,
      FONT.RealistWide.Regular_400,
      FONT.RealistWide.Bold_700
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/afb8gdm.css';
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.ProductTitle, 0],
      [SectionColumnProductInfoType.Brand, 1],
      [SectionColumnProductInfoType.Badge, 2],
      [SectionColumnProductInfoType.Strain, 3],
      [SectionColumnProductInfoType.StrainType, 4],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(5),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(6),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(7, false),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(8),
      [SectionColumnProductInfoType.VariantType, 9],
      [SectionColumnProductInfoType.Stock, 10],
      [SectionColumnProductInfoType.QuantityAndSize, 11],
      [SectionColumnProductInfoType.Quantity, 12],
      [SectionColumnProductInfoType.Size, 13],
      [SectionColumnCannabinoidType.THCAndCBD, 14],
      [SectionColumnProductInfoType.GradingResults, 15],
      [SectionColumnProductInfoType.VariantPrice, 16],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 17]
    ]);
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }
}
